import {
  BrowserCacheLocation,
  InteractionType,
  IPublicClientApplication,
  LogLevel,
  PublicClientApplication,
} from '@azure/msal-browser';
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { environment } from '../../../environments/environment';

export function msalInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.msalConfig.clientId,
      authority: environment.msalConfig.authority,
      knownAuthorities: environment.msalConfig.knownAuthorities,
      redirectUri: environment.msalConfig.redirectUri,
      postLogoutRedirectUri: environment.msalConfig.postLogoutRedirectUri,
      // NOTE: navigateToLoginRequestUrl and storeAuthStateInCookie do NOT exist in MSAL v5
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
    },
    system: {
      loggerOptions: {
        logLevel: LogLevel.Warning,
        piiLoggingEnabled: false,
      },
    },
  });
}

export function msalGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: { scopes: environment.apiScopes },
  };
}

export function msalInterceptorConfigFactory(): MsalInterceptorConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    // /api/auth/identity is called before the user is authenticated (identity-first/HRD lookup on
    // the login screen) — it must be excluded from the wildcard below (mapped to null = no token,
    // no interaction) or MsalInterceptor tries to silently acquire a token, fails since there's no
    // account yet, and immediately triggers an interactive redirect before the call is ever sent.
    protectedResourceMap: new Map<string, Array<string> | null>([
      ['/api/auth/identity', null],
      ['/api/*', environment.apiScopes],
    ]),
  };
}
